"use strict";

module.exports = require("./StringService");